import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { TooltipProvider } from './components/TooltipProvider';
import LoginPage from './components/LoginPage';
import FaceSwapPage from './components/FaceSwapPage';
import ImageToVideoPage from './components/ImageToVideoPage';
import PricingPage from './components/PricingPage';
import SettingsPage from './components/SettingsPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import TermsOfUsePage from './components/TermsOfUsePage';
import CookieNoticePage from './components/CookieNoticePage';
import BlogPage from './components/BlogPage';
import BlogPostPage from './components/BlogPostPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <TooltipProvider>
          <Router>
            <Routes>
              <Route path="/" element={<FaceSwapPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/face-swap" element={<FaceSwapPage />} />
              <Route path="/faceswap" element={<FaceSwapPage />} />
              <Route path="/image-to-video" element={<ImageToVideoPage />} />
              <Route path="/image2video" element={<ImageToVideoPage />} />
              <Route path="/video-gen" element={<ImageToVideoPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsOfUsePage />} />
              <Route path="/terms-of-use" element={<TermsOfUsePage />} />
              <Route path="/terms-of-use-agreement" element={<TermsOfUsePage />} />
              <Route path="/cookie-notice" element={<CookieNoticePage />} />
              <Route path="/cookies" element={<CookieNoticePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
            </Routes>
          </Router>
        </TooltipProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
